import { useQuery } from "@tanstack/react-query";
import { tenantApi } from "../lib/tenant";

// Free-trial countdown banner.
//
//   active trial, > 7 days left  → not shown
//   active trial, ≤ 7 days left  → amber bar with day count
//   trial expired                → red bar with "contact us" link
//   paid plan                    → not shown
//
// Sits just above OfflineBanner in AppShell so it's visible on every page.
export function TrialBanner() {
  const { data: tenant } = useQuery({
    queryKey: ["tenant"],
    queryFn: () => tenantApi.getMe(),
  });
  // Past-due (paid plan but renewal didn't go through) takes priority — those
  // tenants have ≤3 days before downgrade to read-only.
  if (tenant?.subscription_status === "past_due") {
    const periodEnd = tenant.subscription_period_end
      ? new Date(tenant.subscription_period_end).toLocaleDateString()
      : "";
    return (
      <div
        style={{
          padding: "10px 16px",
          background: "#7A1F1F",
          color: "#FFE9E0",
          fontSize: 13,
          textAlign: "center",
        }}
      >
        <strong>Renewal payment didn't go through</strong> (period ended {periodEnd}).
        ClearBooks switches to read-only in 3 days unless payment is sorted.{" "}
        <a
          href="/clearbooks/app/settings/billing"
          style={{ color: "#FFE9E0", textDecoration: "underline" }}
        >
          Fix payment now
        </a>
        .
      </div>
    );
  }

  const trial = tenant?.trial;
  if (!trial || !trial.applies) return null;

  if (trial.is_expired) {
    return (
      <div
        style={{
          padding: "10px 16px",
          background: "#7A1F1F",
          color: "#FFE9E0",
          fontSize: 13,
          textAlign: "center",
        }}
      >
        <strong>Your 30-day free trial has ended.</strong>{" "}
        You can still view and export your books, but new transactions are paused.{" "}
        <a
          href="/clearbooks/app/settings/billing"
          style={{ color: "#FFE9E0", textDecoration: "underline" }}
        >
          Choose a plan
        </a>.
      </div>
    );
  }

  if (trial.days_left != null && trial.days_left <= 7) {
    const dayWord = trial.days_left === 1 ? "day" : "days";
    return (
      <div
        style={{
          padding: "10px 16px",
          background: "#7A4500",
          color: "#FFE7CC",
          fontSize: 13,
          textAlign: "center",
        }}
      >
        Free trial ends in <strong>{trial.days_left} {dayWord}</strong>.{" "}
        <a
          href="/clearbooks/app/settings/billing"
          style={{ color: "#FFE7CC", textDecoration: "underline" }}
        >
          Upgrade now
        </a>{" "}
        to continue without interruption.
      </div>
    );
  }

  return null;
}
